import {SelfAlignType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/SelfAlignType';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {FractionalUnits} from '@mintdata/mint-kit/api/models/FractionalUnits';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {AIntegerConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AIntegerConfig';
import {FractionalUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/FractionalUnitsConfig';
import {PositiveUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/PositiveUnitsConfig';

export class HVBoxChildModel
{
    @Property<SelfAlignType>({
        title: 'Self Align',
        tip: 'Self Align',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: SelfAlignType
    })
    public selfAlign:SelfAlignType;

    @Property<AInteger>({
        title: 'Item Order',
        tip: 'Item Order',
        isRequired: false,
        typeConfig: AIntegerConfig,
        typeCtor: AInteger
    })
    public itemOrder:AInteger;

    @Property<FractionalUnits>({
        title: 'Main Axis Size',
        tip: 'Main Axis Size',
        isRequired: true,
        typeConfig: FractionalUnitsConfig,
        typeCtor: FractionalUnits
    })
    public mainAxisSize:FractionalUnits;

    @Property<PositiveUnits>({
        title: 'Main Axis Min Size',
        tip: 'Main Axis Min Size',
        isRequired: false,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    public mainAxisMinSize:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Main Axis Max Size',
        tip: 'Main Axis Max Size',
        isRequired: false,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    public mainAxisMaxSize:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Cross Axis Size',
        tip: 'Cross Axis Size',
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    public crossAxisSize:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Cross Axis Min Size',
        tip: 'Cross Axis Min Size',
        isRequired: false,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    public crossAxisMinSize:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Cross Axis Max Size',
        tip: 'Cross Axis Max Size',
        isRequired: false,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    public crossAxisMaxSize:PositiveUnits;

    @Property<ABoolean>({
        title: 'Allow Element Shrink',
        tip: 'Allow Element Shrink',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    public allowShrink:ABoolean;

    public constructor(selfAlign:SelfAlignType = SelfAlignType.default(),
                       itemOrder:AInteger = null,
                       mainAxisSize:FractionalUnits = FractionalUnits.fromPixels(100),
                       mainAxisMinSize:PositiveUnits = PositiveUnits.fromPixels(20),
                       mainAxisMaxSize:PositiveUnits = PositiveUnits.auto(),
                       crossAxisSize:PositiveUnits = PositiveUnits.fromPercentages(100),
                       crossAxisMinSize:PositiveUnits = PositiveUnits.fromPixels(20),
                       crossAxisMaxSize:PositiveUnits = PositiveUnits.auto(),
                       allowShrink:ABoolean = ABoolean.false())
    {
        this.selfAlign = selfAlign;
        this.itemOrder = itemOrder;
        this.mainAxisSize = mainAxisSize;
        this.mainAxisMinSize = mainAxisMinSize;
        this.mainAxisMaxSize = mainAxisMaxSize;
        this.crossAxisSize = crossAxisSize;
        this.crossAxisMinSize = crossAxisMinSize;
        this.crossAxisMaxSize = crossAxisMaxSize;
        this.allowShrink = allowShrink;
    }
}
